export default {
  bind(el, binding) {
    if (process.env.NODE_ENV === 'test') {
      Object.entries(binding.value).forEach(([key, value]) => {
        el.setAttribute(`data-test-${key}`, value);
      });
    }
  },
};
